<template>
    <div class="row" style="min-height: 300px">
      <div class="col-md-12" style="text-align: center">
        <h6>{{ this.data.name }}</h6>
      </div>
      <div class="col-md-12" v-if="jobIsInProcess">
        This job is already in process (it has one more completed or cancelled tasks). It cannot be replaced. Please manually delete the job and create a new one.
      </div>
      <div v-else>
        <div class="col-md-12 d-flex" style="margin-top: 25px;">
          <div>
            <v-select
              name="processDefinition"
              data-vv-as="new job"
              id="replace-job"
              v-model="processDefinition"
              label="label"
              value="value"
              placeholder="Select a new Job"
              v-validate="'required'"
              style="min-width: 625px;"
              :options="ptracProcessDefinitionsKvps">
            </v-select>
            <small class="text-danger" v-show="errors.has('processDefinition')">
              {{ getError('processDefinition') }}
            </small>
          </div>
        </div>
        <div class="col-md-12" v-if="!jobIsInProcess" style="margin-top: 25px;">
          <i class="nc-icon nc-alert-circle-i" style="margin-right: 5px" />
          NOTE: This is a destructive action. A new job will be created, field values will be copied from this job to a new one and then the old job will be deleted. This includes tasks and files.
        </div>
        <div class="col-md-12 text-center" style="margin-top: 15px;">
          <button @click="validateAndSubmit" :disabled="isSubmitDisabled" class="btn btn-fill btn-info btn-wd btn-danger">Replace Job</button>
        </div>
      </div>
    </div>
</template>

<script>

import {mapGetters} from 'vuex'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import {OK} from 'http-status-codes'
import {ptracGet, ptracPost} from 'src/utilities/ptracApi'
import {notifyError, notifySuccess} from 'src/utilities/utils'
import _ from 'lodash'

export default {
    props: ['data'],
    components: {
      vSelect
    },
    computed: {
    ...mapGetters({
        user: 'security/user'
      }),
      isSubmitDisabled() {
        return this.processDefinition == null || this.isProcessing
      },
      ptracProcessDefinitionsKvps() {
        const pds = this.$store.get('camunda/ptracKvpsForSelect')
        return _.filter(pds, (pd) => pd.value !== this.data.processDefinitionId)
      }
    },
    data() {
      return {
        processDefinition: null,
        isProcessing: false,
        jobIsInProcess: false
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      async validateAndSubmit() {
        this.isProcessing = true

        if (await this.$validator.validateAll()) {
          const url = `jobs/replace?jobId=${this.data.id}&processDefinitionId=${this.processDefinition.value}`
          const response = await ptracPost(url, null)

          if (OK === response.status) {
            notifySuccess(this, 'Job Replaced Successfully')
            await this.$store.dispatch('jobs/fetchByProjectId', response.data.projectId)
            this.$emit('close')
            return
          }

          notifyError(this, 'Failed to Replace Job')
        }
        this.isProcessing = false
      }
    },
    async beforeMount() {
      const response = await ptracGet('jobs/isEligibleToReplace?jobId=' + this.data.id)

      if (OK === response.status) {
        if (response.data.message === 'no') {
          this.jobIsInProcess = true
        }
      }

      await this.$store.dispatch('camunda/fetchPtracProcessDefinitionsByDepartment', this.data.departmentId)
    },
    beforeDestroy() {
      this.processDefinition = null
    }
}
</script>

<style scoped>

</style>
